export default __webpack_public_path__ + "static/media/wi_0.88acccb0.mp3";